import { apiPost } from './client'

/**
 * Cele cinci intrari din sertarul "Action" al unui rand din lista Managed.
 *
 * Adresele si campurile sunt cele ale capetelor v4
 * (`InventoreeDeviceActionsController`), nu ale celor din portal: acolo
 * "wake" trimitea `device_unique`, "uninstall" trimitea `deviceId`, iar
 * "check if alive" batea la un cu totul alt controller. Numarul masinii intra
 * acum in adresa, o data, la fel pentru toate cinci.
 *
 * Raspunsul poarta `ok`, si - cand fapta n-a putut pleca - un `error` cu
 * motivul. Portalul nu citea niciodata raspunsul: arata "command has been
 * sent" si pentru o masina fara releu, care nu avea cum sa fie trezita.
 */

export interface ActionResult {
  ok: boolean
  error?: string
}

export interface NotifyResult extends ActionResult {
  notify: boolean
}

export function wakeDevice(id: number): Promise<ActionResult> {
  return apiPost<ActionResult>(`/inventoree/devices/${id}/wake`, {})
}

export interface RestartFields {
  /** Ce vede omul pe ecran inainte sa reporneasca. */
  restart_message: string
  /** Secunde pana la repornire: 0, 30, 60 sau 120 in fereastra veche. */
  restart_time: number
  force_restart: boolean
}

export function restartDevice(id: number, fields: RestartFields): Promise<ActionResult> {
  return apiPost<ActionResult>(`/inventoree/devices/${id}/restart`, {
    restart_message: fields.restart_message,
    restart_time: fields.restart_time,
    force_restart: fields.force_restart ? '1' : '0',
  })
}

export function uninstallDevice(id: number): Promise<ActionResult> {
  return apiPost<ActionResult>(`/inventoree/devices/${id}/uninstall`, {})
}

export function checkDeviceAlive(id: number): Promise<ActionResult> {
  return apiPost<ActionResult>(`/inventoree/devices/${id}/check-alive`, {})
}

export function setNotifyWhenAlive(id: number, on: boolean): Promise<NotifyResult> {
  return apiPost<NotifyResult>(`/inventoree/devices/${id}/notify`, { status: on ? '1' : '0' })
}
